import React from 'react';
import { PromoBlockVariant, VariantComponentProps } from './types';
import AppointmentCTA from './variants/AppointmentCTA';
import BasicCta from './variants/BasicCta';
import FloatingCTA from './variants/FloatingCTA';
import TextCTA from './variants/TextCTA';

type PromoBlockVariantMap = {
  [V in PromoBlockVariant]: React.FC<VariantComponentProps<V>>;
};

export const promoBlockVariantMap: PromoBlockVariantMap = {
  floating: FloatingCTA,
  appointment: AppointmentCTA,
  basic: BasicCta,
  text: TextCTA,
};
